import { render, staticRenderFns } from "./ChildSettingsPanelsNoDevice.vue?vue&type=template&id=2cdbada7&scoped=true&"
import script from "./ChildSettingsPanelsNoDevice.vue?vue&type=script&lang=js&"
export * from "./ChildSettingsPanelsNoDevice.vue?vue&type=script&lang=js&"
import style0 from "./ChildSettingsPanelsNoDevice.vue?vue&type=style&index=0&id=2cdbada7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdbada7",
  null
  
)

export default component.exports